export default __webpack_public_path__ + "static/media/slide5.123e10a5.jpg";